import { Facebook, Instagram, WhatsApp } from "@mui/icons-material";
import { Link } from "react-router";

const SERVICES = ["Consulta General", "Vacunación", "Control de Peso y Nutrición", "Emergencias 24/7", "Odontología Veterinaria", "Laboratorio y Análisis"];

export default function HeyVetFooterComponent() {
    return (
        <footer className="hv-footer">
            <div className="hv-container">
                <div className="hv-footer-grid">
                    {/* Brand Column */}
                    <div>
                        <Link to="/e7b3a1f2-8c4d-4f5e-9a6b-2d1c3e4f5a6b" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", marginBottom: 20 }}>
                            <span className="material-symbols-outlined" style={{ color: "white", fontSize: 36 }}>pets</span>
                            <span style={{ fontSize: "1.6rem", fontWeight: 800, color: "white", fontFamily: "'Poppins', sans-serif" }}>
                                HeyVet
                            </span>
                        </Link>
                        <p style={{ fontSize: "0.95rem", lineHeight: 1.7, fontFamily: "'Nunito Sans', sans-serif", opacity: 0.9, maxWidth: 300 }}>
                            Cuidamos de los que más amas. Conectamos a tu mascota con los mejores especialistas veterinarios, al instante y sin estrés.
                        </p>
                    </div>

                    {/* Services */}
                    <div>
                        <h4 className="hv-footer-title">Servicios Médicos</h4>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                            {SERVICES.map((s) => (
                                <li key={s}>
                                    <a href="#" className="hv-footer-link" style={{ fontFamily: "'Nunito Sans', sans-serif" }}>{s}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h4 className="hv-footer-title">HeyVet</h4>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                            {["Nosotros", "Blog", "Preguntas Frecuentes", "Médicos Veterinarios"].map((label) => (
                                <li key={label}>
                                    <a href="#" className="hv-footer-link" style={{ fontFamily: "'Nunito Sans', sans-serif" }}>{label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact & Social */}
                    <div>
                        <h4 className="hv-footer-title">Contacto</h4>
                        <p style={{ fontFamily: "'Nunito Sans', sans-serif", marginBottom: 12, opacity: 0.9 }}>
                            contacto@heyvet.com.mx<br />
                            800 123 4567
                        </p>
                        
                        <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
                            {[
                                { icon: <WhatsApp sx={{ fontSize: 20 }} />, label: "WhatsApp" },
                                { icon: <Facebook sx={{ fontSize: 20 }} />, label: "Facebook" },
                                { icon: <Instagram sx={{ fontSize: 20 }} />, label: "Instagram" },
                            ].map(({ icon, label }, i) => (
                                <a
                                    key={i}
                                    href="#"
                                    aria-label={label}
                                    style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "50%",
                                        background: "rgba(255,255,255,0.1)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        transition: "background .2s",
                                        textDecoration: "none",
                                    }}
                                    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.background = "rgba(255,255,255,0.2)"; }}
                                    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.background = "rgba(255,255,255,0.1)"; }}
                                >
                                    {icon}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: 24, display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
                    <p style={{ margin: 0, fontSize: "0.875rem", fontFamily: "'Nunito Sans', sans-serif", opacity: 0.7 }}>
                        © 2026 HeyVet (HeyDoctor). Todos los derechos reservados.
                    </p>
                    <div style={{ display: "flex", gap: 24, fontSize: "0.875rem", fontFamily: "'Nunito Sans', sans-serif" }}>
                        <a href="#" className="hv-footer-link" style={{ marginBottom: 0 }}>Términos de servicio</a>
                        <a href="#" className="hv-footer-link" style={{ marginBottom: 0 }}>Privacidad</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
